/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface PrepaidBankTransferEmailRequest
 */
export interface PrepaidBankTransferEmailRequest {
    /**
     * Amount to be printed on the payment slips
     * @type {number}
     * @memberof PrepaidBankTransferEmailRequest
     */
    amount: number;
    /**
     * 
     * @type {Currency}
     * @memberof PrepaidBankTransferEmailRequest
     */
    currency: Currency;
}

/**
 * Check if a given object implements the PrepaidBankTransferEmailRequest interface.
 */
export function instanceOfPrepaidBankTransferEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "currency" in value;

    return isInstance;
}

export function PrepaidBankTransferEmailRequestFromJSON(json: any): PrepaidBankTransferEmailRequest {
    return PrepaidBankTransferEmailRequestFromJSONTyped(json, false);
}

export function PrepaidBankTransferEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrepaidBankTransferEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': CurrencyFromJSON(json['currency']),
    };
}

export function PrepaidBankTransferEmailRequestToJSON(value?: PrepaidBankTransferEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'currency': CurrencyToJSON(value.currency),
    };
}

